"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPropertyKey = void 0;
const isPropertyKey = (x) => {
    switch (typeof (x)) {
        case 'string':
        case 'number':
        case 'symbol':
            return true;
        default:
            return false;
    }
};
exports.isPropertyKey = isPropertyKey;
//# sourceMappingURL=util.js.map